export default {
    addToast(state, notify) {
        state.notify.push(notify);
    },

    clearToast(state, nameCreator) {
        const index = state.notify.findIndex((notify) => notify.nameCreator === nameCreator);
        state.notify.splice(index, 1);
    }
}